import { Injectable } from '@angular/core';
import { UserManager, UserManagerSettings, User, Log  } from 'paycor-oidc-client';

@Injectable()
export class AuthService {
    private manager = new UserManager(getClientSettings());
    private user: User = null;

    constructor() {
        Log.logger = console;

        // Create fake user here for local testing. See readme.txt for more details.

        this.manager.getUser().then(user => {
            this.user = user;
        });
    }

    getUser(): Promise<User> {
        if (this.user == null || this.user.expired) {
            return this.manager.getUser();
        }
        else {
            return Promise.resolve(this.user);
        }
    }

    getAuthorizationHeaderValue(): string {
        if (this.user != null && !this.user.expired) {
            return `${this.user.token_type} ${this.user.access_token}`;
        }
        else {
            return this.manager.getAuthorizationHeader();
        }
    }

    startAuthentication(): Promise<User> {
        return this.manager.signinSilent().then(user => {
            console.log(user);
            this.user = user;
            return user;
        }).catch(err => {
            console.log(`Failed to authenticate at ${this.manager.settings.client_id}`)
            console.log(err);
            window.location.href = `${window.location.origin}/accounts/authentication/signin?returnUrl=${window.location.href}`;
            return null;
        });
    }
}
 

export function getClientSettings(): UserManagerSettings {
    return {
        authority: `${process.env.AppSettings.apiBaseUrl}sts/v1/common`,
        client_id: 'MySettingsUI',
        silent_redirect_uri: `${window.location.origin}/mysettings/silent_renew/`,
        redirect_uri: `${window.location.origin}/mysettings/silent_renew/`,
        response_type: "token",
        scope: "MySettingsUI",
        filterProtocolClaims: true,
        loadUserInfo: false,
        extraQueryParams: { 'subscription-key': process.env.AppSettings.apimKey },
        automaticSilentRenew: true
    };
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/auth/AuthService.ts